import React from "react";
import PropTypes from "prop-types";

import GeneralInformationForm from "../../../../components/lsp/generalinfo/GeneralInfoFrom";

const GeneralInformation = ({ generaldata, handleChange }) => {
  return (
    <div className="formgrid grid">
      <div className="field">
        <p className="general-info">General Information</p>
      </div>
      <GeneralInformationForm
        generaldata={generaldata}
        handleChange={handleChange}
        isLoading={false}
        isEdit={true}
      />
    </div>
  );
};

GeneralInformation.propTypes = {
  generaldata: PropTypes.object,
  handleChange: PropTypes.func,
};

export default GeneralInformation;
